import React, { forwardRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InputContainer } from "./input.style";
import { IInputProps } from "./types";

const Input = forwardRef<HTMLInputElement, IInputProps>(
  (
    {
      className,
      containerClassName,
      placeholder,
      required = false,
      onChange,
      value,
      title,
      type = "text",
      disabled = false,
      autoFocus = false,
      autoComplete,
      icon,
      inputMode,
      justNumber = false,
      accept,
      id,
    },
    ref
  ) => {
    const validatorFunctions: {
      [key: string]: { validate: (value: string) => boolean; message: string };
    } = {
      english: {
        validate: (value: string) => /^[A-Za-z\d]*$/.test(value),
        message: "شما فقط مجاز به وارد کردن حروف انگلیسی هستید",
      },
      persian: {
        validate: (value: string) => /^[\u0600-\u06FF\d\s]*$/.test(value),
        message: "شما فقط مجاز به وارد کردن حروف فارسی و عدد هستید",
      },
      number: {
        validate: (value: string) => /^\d*$/.test(value),
        message: "شما فقط مجاز به وارد کردن عدد هستید",
      },
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;

      if (accept) {
        const validateFunc = validatorFunctions[accept];
        if (validateFunc && !validateFunc.validate(newValue)) {
          toast.error(validateFunc.message);
          return;
        }
      }

      onChange(newValue);
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (justNumber && (e.key < "0" || e.key > "9")) {
        e.preventDefault();
      }
    };

    return (
      <InputContainer className={`${containerClassName || ""}`}>
        {title && (
          <p className="title">
            {title}
            {required && <span className="required">*</span>}
          </p>
        )}
        <div className="input_container">
          <input
            id={id}
            type={type}
            disabled={disabled}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            autoFocus={autoFocus}
            className={`input ${className || ""}`}
            value={value}
            placeholder={placeholder || ""}
            ref={ref}
            inputMode={inputMode}
          />
          {icon && <span className="left_icon">{icon}</span>}
        </div>
      </InputContainer>
    );
  }
);

export { Input };
